import { useMemo } from 'react';
import { UserRole, getPrimaryRole, roleMatches } from 'src/domain/user';
import { useSignedInUser } from './useSignedInUser';

// hook check if user logged in
export const useRoleUserAuthenticated = (
    requiredRoles: UserRole[] | undefined,
): boolean => {
    const user = useSignedInUser();

    const auth = useMemo(() => {
        if (!requiredRoles) {
            return true;
        }
        if (!user) {
            return false;
        }

        const role = getPrimaryRole(user);
        if (!role) {
            return false;
        }

        const roleAccepted = requiredRoles.some(requiredRole =>
            roleMatches(role, requiredRole),
        );

        return roleAccepted;
    }, [requiredRoles, user]);

    return auth;
};
